import { render, staticRenderFns } from "./TopTitleComponent.vue?vue&type=template&id=f47f24dc&scoped=true&"
import script from "./TopTitleComponent.vue?vue&type=script&lang=js&"
export * from "./TopTitleComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopTitleComponent.vue?vue&type=style&index=0&id=f47f24dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47f24dc",
  null
  
)

export default component.exports